/*
 * @Author: bz2021 bz2021@mail.sdu.edu.cn
 * @Date: 2025-07-07 11:06:14
 * @LastEditors: bz2021 bz2021@mail.sdu.edu.cn
 * @LastEditTime: 2025-07-07 11:19:38
 * @FilePath: \a_span\frontend\management-app\src\store\userAtom.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { atom } from 'jotai';

// 用户列表原子
export const usersAtom = atom([]);
// 用户总数原子
export const totalAtom = atom(0);
// 当前选中用户原子
export const currentUserAtom = atom(null);
// 当前登录用户原子
export const loggedInUserAtom = atom(null);

export const storesAtom = atom(null);